export type PhxCollapseType = 'caption' | 'default' | 'title';

export const PHX_COLLAPSE_TYPE: Record<string, PhxCollapseType> = {
  CAPTION: 'caption',
  DEFAULT: 'default',
  TITLE: 'title',
} as const;
